export interface Tariff_Interface {
  id:number,
  device_id:number,
  device_name:String,
  quantity:String,
  quantity_sub:String,
  dsc:String,
  tariff:number,
  tariff_expert:number,
  tariff_hazineh:number,
  username:String,
  expiredDate:String,
  persianDate:String,
  del:boolean,
  modirPrice:number,
  
  t1:number,
  t2:number,
  t3:number,
  t4:number,
}

export function Empty_Tariff_Interface():Tariff_Interface{
  return{
    id:0,
    device_id:0,
    modirPrice:0,
    device_name:'',
    expiredDate:'',
    quantity:'',
    quantity_sub:'',
    dsc:'',
    tariff:0,
    tariff_expert:0,
    tariff_hazineh:0,
    username:'',
    persianDate:'',
    del:false,
    
    t1:0,
    t2:0,
    t3:0,
    t4:0,
  }
}
